import React, { useState } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { rjscAdvanceSearchResultSelect } from "../../redux/selector/rjscSearchSelector";
import {
  Header,
  Paragraph,
  Button,
  ErrorMark,
  LineSeperator,
  NavigationLinkButton,
} from "../../components/RegularComponents";
import TopNavigationBar from "../TopNavigationBar";
import { Pagination } from "../../components/Pagination/Pagination";
import { fetchRjscFromNumberAndSetDetails } from "../../redux/slice/rjscSearchSlice";
import { 
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, 
  COMPANY_TRADEMARK_HOME_LINK, 
  RJSC_PAGE_LINK, 
  ROUTE_PATH 
} from "../../app/constants";
import { setCompanyTrademark } from "../../redux/slice/primaryAgencyApplicationSlice";
import { ERROR_STRING } from "../../app/errors";

const MraRJSCAdvanceSearchResult = (props) => {
  const { rjscAdvanceSearchResult, dispatch } = props;

  //const [rjscSearchRegistryNumber, setRjscSearchRegistryNumber] = useState(rjscAdvanceSearchResult.advanceSearchText)
  // const [rjscLegalBusinessRegistryNumber, setRjscLegalBusinessRegistryNumber] =
  //   useState(rjscAdvanceSearchResult.advanceSearchText);
  const [
    rjscOperatingBusinessRegistryNumber,
    setRjscOperatingBusinessRegistryNumber,
  ] = useState("");

  const [companyTrademarkText, setCompanyTrademarkText] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showError, setShowError] = useState(false);
  const [fetchingRjscDetails, setFetchingRjscDetails] = useState(false);

  const [showUpdateRjscDetailDialog, setShowUpdateRsjcDetailDialog] =
    useState(false);

  const [showValidationError, setShowValidationError] = useState(false)
  const [validationError, setValidationError] = useState(null)

  const itemsPerPage = 100;

  /* There are two paths from here : 
     1. If the search is with the rjsc number : 
          - Assumption here is that the selected business is already 
            the operating business.
     2. If the search is with rjsc name :
          - The selected name is legal name. 
          - We need to search the operating business names for the selected entity.
          - There are three options from here : 
              - A. There are no operating businesses
                    - Keep the selected legal name as operating business 
              - B. There is exactly one operating business
                    - Keep the single operating business as the operating business
              - C. There are multiple operating businesses
                    - Show all options and let user select the operating business
    */
  const onNextClick = () => {
    if (fetchingRjscDetails) return;
    setShowValidationError(false)

    if(rjscOperatingBusinessRegistryNumber !== null && 
        rjscOperatingBusinessRegistryNumber !== "" && 
        companyTrademarkText !== null && 
        companyTrademarkText !== "") 
    {
        setShowValidationError(true)
        setValidationError(ERROR_STRING.RJSC_OPERATING_NAME_TRADEMARK_NAME_BOTH_ENTERED)
        return
    }

    let targetRegistryNumber = rjscOperatingBusinessRegistryNumber;

    // if user did not select any operating name from the list, then
    // take the legal business registry number as the registry number.
    if (!rjscOperatingBusinessRegistryNumber) {
      targetRegistryNumber = rjscAdvanceSearchResult.advanceSearchText;
    }

    setFetchingRjscDetails(true);
    
    dispatch(setCompanyTrademark(companyTrademarkText))

    dispatch(fetchRjscFromNumberAndSetDetails(targetRegistryNumber))
      .then((data) => {
        dispatch(
          push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RJSC_DETAIL_REVIEW}`)
        );
      })
      .catch((err) => {
        setShowError(true);
      });
  };

  const currentPageItems = () => {
    if (
      !rjscAdvanceSearchResult ||
      !rjscAdvanceSearchResult.advanceSearchResponseData
    )
      return [];

    const startIndex = (currentPage - 1) * itemsPerPage;
    return rjscAdvanceSearchResult.advanceSearchResponseData.slice(
      startIndex,
      startIndex + itemsPerPage
    );
  };

  // As per the flow, the legal business entity is the item where the registryNumber is the search text
  const legalBusinessEntities = () => {

    // if there is only one item in the response, 
    // treat that item as legal entity regarless of the 
    // isParentEntity flag.
    if(rjscAdvanceSearchResult?.advanceSearchResponseData?.length === 1) {
      return rjscAdvanceSearchResult.advanceSearchResponseData
    }

    return currentPageItems().filter(
      (item) => item.isParentEntity
    );
  };

  const operatingBusinessEntities = () => {
    // if there is only one item in the response, 
    // treat that item as legal entity regarless 
    // of the isParentEntity flag and operating 
    // business entities will be blank.
    if(rjscAdvanceSearchResult?.advanceSearchResponseData?.length === 1) {
      return []
    }

    return currentPageItems().filter(
      (item) => !item.isParentEntity
    );
  };

  const totalPages = () => {
    if (
      !rjscAdvanceSearchResult ||
      !rjscAdvanceSearchResult.advanceSearchResponseData
    )
      return 0;

    return (
      parseInt(
        rjscAdvanceSearchResult.advanceSearchResponseData.length / itemsPerPage
      ) +
      (rjscAdvanceSearchResult.advanceSearchResponseData.length % itemsPerPage >
      0
        ? 1
        : 0)
    );
  };

  return (
    <>
      <div className="container">
        <TopNavigationBar {...props} 
          applicationType={APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE} 
          applicationMode={APPLICATION_MODE_NEW} />

        <div className="row">
          <div className="col-lg-8">
            <Header
              id="rjs-search-results-header"
              header={"Business names and trademark"}
            />
            <Paragraph
              id="rjsc-advance-searchs-text"
              text={[
                "Your company's legal name will be on your licence. If your company has an operating/business name or a federally registered trademark that you use to advertise services, those names must also appear on the licence.",
              ]}
            />
          </div>
        </div>

        <div className={"row"}>
          <div className={"col-8"}>
            <h3>Legal Business Name</h3>
            <Paragraph
              id="rjsc-advance-searchs-text"
              text={[
                "Your legal name will appear on your licence as",
              ]}
            />
            {legalBusinessEntities().map((d) => {
              const { registryNumber, entityId, businessName } = d;

              return (
                <div key={entityId} >
                  <span>
                    <b>
                    {`${businessName} (# ${registryNumber})`}
                    </b>
                  </span>
                </div>
              );
            })}
            {/* <fieldset className="ns-fieldset">
              <div className={"ns-radios ns-radios--small"}>
                {legalBusinessEntities().map((d) => {
                  const { registryNumber, entityId, businessName } = d;

                  return (
                    <div key={entityId} className="ns-radios__item">
                      <input
                        className="ns-radios__input"
                        key={entityId + "-input"}
                        type={"radio"}
                        value={registryNumber}
                        checked={
                          rjscLegalBusinessRegistryNumber === registryNumber
                        }
                        onChange={(e) =>
                          setRjscLegalBusinessRegistryNumber(e.target.value)
                        }
                        id={"rjsc-advance-search-legal-" + entityId + "-input"}
                        name={"rjsc-advance-search-legal-business-group"}
                      />
                      <label
                        key={entityId + "-label"}
                        id={"rjsc-advance-search-legal-" + entityId + "-label"}
                        className="ns-radios__label"
                        htmlFor={
                          "rjsc-advance-search-legal-" + entityId + "-input"
                        }
                      >
                        <span className="ns-label-span">
                          {`${businessName} (# ${registryNumber})`}
                        </span>
                      </label>
                    </div>
                  );
                })}
              </div> 
            </fieldset> */}
          </div>
        </div>

        {operatingBusinessEntities().length > 0 ? 
        <>
          <div className="row">
            <div className="col-lg-8">
              <LineSeperator />
            </div>
          </div>

          <div className="row">
            <div className="col-lg-8">
              <h3>
                Select your operating name, if your company name uses one.
              </h3>
              <Paragraph
                id="rjsc-advance-searchs-text"
                text={[
                  "Your company licence needs to include your operating name if it’s the business name that you use to advertise services to the public. Your operating name must have a \"Active\" status in RJSC.",
                ]}
              />
            </div>
          </div>

          <div className={"row"}>
            <div className={"col-8"}>
              <fieldset className="ns-fieldset">
                <div className={"ns-radios ns-radios--small"}>
                  {operatingBusinessEntities().map((d) => {
                    const { registryNumber, entityId, businessName } = d;

                    return (
                      <div key={entityId} className="ns-radios__item">
                        <input
                          className="ns-radios__input"
                          key={entityId + "-input"}
                          type={"radio"}
                          value={registryNumber}
                          checked={
                            rjscOperatingBusinessRegistryNumber === registryNumber
                          }
                          onClick={(e) =>
                            {
                              if(rjscOperatingBusinessRegistryNumber === e.target.value) {
                                setRjscOperatingBusinessRegistryNumber("")
                              } else {
                                setRjscOperatingBusinessRegistryNumber(e.target.value)
                              }
                            }
                          }
                          id={
                            "rjsc-advance-search-operating-" + entityId + "-input"
                          }
                          name={"rjsc-advance-search-operating-business-group"}
                        />
                        <label
                          key={entityId + "-label"}
                          id={
                            "rjsc-advance-search-operating-" + entityId + "-label"
                          }
                          className="ns-radios__label"
                          htmlFor={
                            "rjsc-advance-search-operating-" + entityId + "-input"
                          }
                        >
                          <span className="ns-label-span">
                            {`${businessName} (# ${registryNumber})`}
                          </span>
                        </label>
                      </div>
                    );
                  })}
                </div>
              </fieldset>
            </div>
          </div>

          {totalPages() > 1 ? (
            <div className="row">
              <div className="col-8">
                <Pagination
                  totalPages={totalPages()}
                  currentPage={currentPage}
                  onPageChange={(pageNum) => {
                    setCurrentPage(pageNum);
                  }}
                />
              </div>
            </div>
          ) : null}
        </>
        : null}

        <div className="row">
          <div className="col-8">
            <LineSeperator />

            <h3>Company trademark</h3>
            <p>
            {`If your company operates under `} 
              <a style={{textDecoration: "underline"}} 
                 rel="noreferrer" 
                 href={COMPANY_TRADEMARK_HOME_LINK} 
                 target="_blank">
                  {`a federally registered trademark name`}
                </a>
              {`, enter it here.
              Continue to the next step if your company doesn't operate under a ` + 
              `a federally registered trademark name.`}
            </p>
            <fieldset className="ns-fieldset">
              <div className={"ns-fieldset"}>
                <label
                  className="ns-label"
                  htmlFor={"trademark-form-trademark-text"}
                  id={"trademark-form-trademark-label"}
                >
                  {"Trademark name"}
                </label>
                <input
                  id={"trademark-form-trademark-text"}
                  name={"trademark-form-trademark-text"}
                  className={"fw-20 ns-input"}
                  type={"text"}
                  value={companyTrademarkText}
                  onInput={(e) => {
                    setCompanyTrademarkText(e.target.value);
                  }}
                  style={{ width: "350px" }}
                />
              </div>
            </fieldset>
          </div>
        </div>

        <div className="row bottomMarginNormal">
          <div className={"col-lg-2" + ((showError || showValidationError) ? " has-error" : "")}>
            <Button
              showSpinner={fetchingRjscDetails}
              id="rjsc-advance-search-button"
              text={"Continue"}
              buttonType={"regular_primary"}
              style={{ marginTop: "15px" }}
              onClick={onNextClick}
            />
            {(showError || showValidationError) && ErrorMark()}
          </div>
          <div
            style={{ marginTop: "20px"}}
            className="col-lg-4"
          >
            <NavigationLinkButton 
              text="My preferred company name isn't there"
              onClick={() => {
                setShowUpdateRsjcDetailDialog(true)
              }}
            />
            {/* <div className="help-block bottomMarginNormal">
                <a href={RJSC_PAGE_LINK} target="blank" style={{padding: "6px"}}>
                  My preferred company name isn't there
                </a>
            </div> */}
          </div>
        </div>
        {showError && (
          <div className="ns-error-message help-block">
            {"Could not find RJSC details"}
          </div>
        )}
        {showValidationError && (
          <div className="ns-error-message help-block">
            {validationError}
          </div>
        )}
      </div>

      <Modal
          appElement={document.getElementById("root")}
          isOpen={showUpdateRjscDetailDialog}
          contentLabel="rjscDetailUpdateDialog"
          onRequestClose={() => {}}
          shouldCloseOnEsc={false}
          shouldCloseOnOverlayClick={false}
          className="modalDialogContent"
          closeTimeoutMS={150}
        >
          <div className="row pull-right">
            <div
              className="col-lg-1 closeButton"
              onClick={() => {
                setShowUpdateRsjcDetailDialog(false);
              }}
            >
              <i className="fa fa-2x fa-times"></i>
            </div>
          </div>
          <Header header={"Update your company name"} />
          <p>
            Update your company name in the Registry of Joint Stock Companies (RJSC) before you continue the application.
          </p>
          <div className="row">
              <div className="col-lg-3">
                <a
                  className={"btn btn-primary"}
                  href={RJSC_PAGE_LINK}
                  target={"_blank"}
                  rel={"noreferrer"}
                  id={"update-rjsc-anchor"}
                >
                  {"Continue to RJSC"}
                </a>
              </div>
              <div className="col-lg-2">
                <NavigationLinkButton
                  text="Cancel"
                  onClick={() => setShowUpdateRsjcDetailDialog(false)}
                />
              </div>
          </div>
          
        </Modal>
      
    </>
  );
};

export default connect(rjscAdvanceSearchResultSelect)(
  MraRJSCAdvanceSearchResult
);
